import { FilterResults } from '@api';
import { getTimeTillEndOfDayMs } from '@helpers';
import { useQuery } from '@tanstack/react-query';
import { ActiveFilterOptions } from '@terminal/components/filters/Filters';
import { mapFilters } from '@terminal/views/screener/use-screener-store/filter-utils';

import {
  fetchFilteredEntitiesTagsOnly,
  getPostFilterEntitiesPath,
} from './entity-screener-service/entity-screener-service';
import { hasEmptyEntityTagValues } from './entity-screener-service/utils';

export const QUERY_KEY_SCREENER_ENTITIES_TAGS =
  'QUERY_KEY_SCREENER_ENTITIES_TAGS';

export const getScreenerEntitiesTagsQueryConfig = ({
  filterOptions,
  defaultOptionsMapped = {},
}: {
  filterOptions: ActiveFilterOptions[];
  defaultOptionsMapped?: Record<
    string,
    {
      values: Record<string, unknown>[];
      children?: Record<string, unknown>[];
    }
  >;
}) => {
  const staleTime = getTimeTillEndOfDayMs();

  const filterOptionsMapped = {
    ...defaultOptionsMapped,
    ...mapFilters(filterOptions),
  };
  const enabled =
    (!!filterOptions.length || Object.keys(defaultOptionsMapped).length > 0) &&
    !hasEmptyEntityTagValues(filterOptionsMapped);

  return {
    queryKey: [
      QUERY_KEY_SCREENER_ENTITIES_TAGS,
      filterOptionsMapped,
      getPostFilterEntitiesPath(),
    ],
    queryFn: ({ signal }: { signal: AbortSignal }) =>
      fetchFilteredEntitiesTagsOnly(filterOptionsMapped, signal),
    staleTime,
    enabled,
  };
};

export const useScreenerEntitiesTags = ({
  filterOptions,
  defaultOptionsMapped,
}: {
  filterOptions: ActiveFilterOptions[];
  defaultOptionsMapped?: Record<
    string,
    {
      values: Record<string, unknown>[];
      children?: Record<string, unknown>[];
    }
  >;
}) => {
  const queryConfig = getScreenerEntitiesTagsQueryConfig({
    filterOptions,
    defaultOptionsMapped,
  });

  return useQuery<FilterResults>(queryConfig);
};

export const mapEntityTagsToDefaultOptions = (entityTags: string[]) => {
  return {
    entity_tag: {
      values: [
        {
          tags: entityTags,
        },
      ],
      children: [],
    },
  };
};
